<template>
<v-container>

  <v-card
    class="lighten-4"
    max-width="360"
    min-width="240"
    :class=cardColor
    outlined
    :elevation=cardElevation
  >

      <div
        class="font-weight-light body-2"
        ref="url_link"
        @click="copyToClipboard(cardio.url)"
      >
        <!-- {{ cardio.hostname.substr(0, 16) }} -->
        <span class="pa-2 mx-1 text-lowercase">
          {{ cardio.hostname.replace(/^www./, '').replace(/\.com$/, '').substr(0, 32) }}
        </span>

        <!--  <v-spacer/> -->
        <div class="float-right">
          <v-btn icon @click.stop="showEdit()">
            <v-icon small>mdi-dots-vertical</v-icon>
          </v-btn>
        </div>

      </div>

      <div @click="showPreview()" class="mx-2 pa-1">{{ cardio.note }}</div>


      <v-spacer />

       <v-chip small
        v-for="(item, idx) in nes"
        :key="idx"
        :item="item"
        class="ml-2 mt-3"
      >
        <span class="ml-0">{{ item }}</span>
      </v-chip>

      <v-card-actions>
        <v-btn
            icon
            @click="fetchDetails()"
            class=""
          >
            <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>

        <v-btn
          class=""
          icon
          color=""
          @click="gotoX(cardio.url)"
        >
          <v-icon
            small
            class=""
          >
            open_in_new
          </v-icon>
        </v-btn>


        <v-spacer />

        <div class="float-left">
          <v-btn icon
            @click="fliploveit()"
          >
            <v-icon :color="loveitcolor">
              mdi-heart
            </v-icon>
          </v-btn>


          <v-btn icon
            @click="flipseenit();"
            class="mx-2"
          >
            <v-icon :color="seenitcolor">check</v-icon>
          </v-btn>

        </div>
      </v-card-actions>

      <v-expand-transition>

    <div v-show="show">


      <v-card-text>

        <!--  <p>{{ item.id }}<br/>
          {{ cardio.created_time }}</p> -->

<!--         <p>Sentiment: Happy</p>
        <p>Keywords: is, a, the</p>
 -->

      <!-- <p>Workbooks</p> -->
      <v-select
        class="mt-0"
        v-model="value"
        :items="items"
        
        dense
        label="Folders"
        multiple
        outlined
      />


     <p>Notes</p>

     <p>Summary of the article</p>


<!-- 
      <p>Features</p>
      <div>

      <v-chip small
        class="mx-2"
      >
        <v-progress-circular
          size="16"
          rotate="90"
          color="green"
          :value="getRandomInt(22,68)"
        />
        <span class="ml-1">Complex</span>
      </v-chip>

      <v-chip small
        class="mx-2"
      >
        <v-progress-circular
          size="16"
          rotate="90"        
          color="purple lighten-2"
          :value="getRandomInt(55,95)"
        />
        <span class="ml-1">Long</span>
      </v-chip>



      <v-chip small
        class="mx-2 mt-3"
      >
        <v-progress-circular
          size="16"
          rotate="90"        
          color="purple lighten-2"
          :value="getRandomInt(55,95)"
        />
        <span class="ml-1">Happy</span>
      </v-chip>
      </div>



      <p class="mt-3">Resources</p>
 -->


      </v-card-text>





    </div>
  </v-expand-transition>
  </v-card>
</v-container>
</template>

<script>

export default {
  name: 'Card',
  // components: {
  // },
  props: ['item'],
  computed: {
    // ...mapGetters({
    // }),
    nes() {
      // console.log(this.cardio.nes)
      return this.cardio.nes
    },
    cardio() {
      return this.$store.getters.included(this.item.id);
    },
    isActiveDoc() {
      return (this.$store.getters['ui/activeDoc'] === this.item.id)
    },
    cardColor() {
      return this.isActiveDoc ? 'grey lighten-2' : 'grey';
    },
    cardElevation() {
      return this.isActiveDoc ? 8 : 2;
    },
    loveitcolor() {
      return this.cardio.loveit ? 'red' : 'grey lighten-1';
    },
    seenitcolor() {
      return this.cardio.seenit ? 'blue lighten-1' : '';
    },
    trashitcolor() {
      return this.cardio.trashit ? 'black' : '';
    },

  },
  methods: {
    fetchDetails() {
      var vm = this;
      vm.show = !vm.show;
    },
    showPreview() {
      console.log('  - click showPreview [Card]')
      console.log(`    docID: ${this.item.id}`)
      this.$store.dispatch('ui/showPreviewWin', this.item.id)      
    },
    showEdit() {
      console.log('  - click showEditForm [Card]')
      console.log(`    docID: ${this.item.id}`)
      this.$store.dispatch('ui/showEditForm', this.item.id)
    },
    fliploveit() {
      var ret = this.$store.dispatch('flipLoveIt', this.item.id).then(response => {
          this.$store.dispatch('ui/raiseInfo', 'success: ' + response.status);
      }).catch(e => {
        this.$store.dispatch('ui/raiseError', e);
      });
      return ret;
    },
    flipseenit() {
      var ret = this.$store.dispatch('flipSeenIt', this.item.id).then(response => {
          this.$store.dispatch('ui/raiseInfo', 'success: ' + response.status);
      }).catch(e => {
        this.$store.dispatch('ui/raiseError', e);
      });
      return ret;
    },
    fliptrashit() {
      var ret = this.$store.dispatch("flipTrashIt", this.item.id);
      return ret;
    },
    gotoX: href => {
      var win = window.open(href, '_blank');
      win.focus();
      console.log(href);
    },
    getFile: hash => {
      return hash;
    },
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    copyToClipboard: str => {
      const el = document.createElement('textarea');
      el.value = str;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      console.log('copied to clipboard: ' + str);
      alert('URL copied to clipboard');
    },
  },
  data: () => ({
    showDialog: false,
    expstatus: 'hidden',
    show: false,
    items: ['Tech', 'Biz', 'Fin', 'SocPol'],
    value: ['Tech'],
  }),

}
</script>




<!-- <v-spacer></v-spacer>


// sentval() {
//   var el = this.$store.getters.included(this.item.id);
//   if ('ta' in el) {
//     var ret = el.ta[0];
//     return ret;
//   } else {
//     return '-';
//   }
// },
// rrank() {
//  return Math.ceil(Math.random() * 1000); 
// },

// var ret = this.$store.dispatch("pullTA", this.item.id).then(() => {
//   vm.show = !vm.show;
// });
// console.log(ret);


 -->


<!--           <v-btn icon
color="light-blue accent-4"
:ripple="{ class: 'red--text' }"
@click="showDialog = true"
>
<v-icon>mdi-head-heart</v-icon>
</v-btn>
-->
<!-- <v-icon>mdi-brain</v-icon> -->
<!-- <v-spacer /> -->


<!-- 
<v-btn icon
@click="fliptrashit()"
>
<v-icon small :color="trashitcolor">
delete
</v-icon>
</v-btn> -->

        <!-- <v-spacer /> -->

<!--             <v-icon
  small
  class="ml-1"
>
  mdi-content-copy
</v-icon>
 -->


<!--       <v-chip
class="ma-2"
label
small
:if="cardio.source"
>
<v-icon left>mdi-label</v-icon>
{{ cardio.source }}
</v-chip>
-->

<!--    <v-rating
:value="Math.ceil(Math.random() * 5)"
color="light-blue lighten-2"
dense
half-increments
readonly
size="14"
></v-rating> -->


<!-- 
<v-card-text>
<v-row
align="center"
class="mx-0"
>

</v-row>

<div class="text--primary">
Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
</div>
</v-card-text>

<v-icon small>mdi-dots-vertical</v-icon>
-->

<!-- </v-list-item-subtitle> -->

<!-- <v-list-item-subtitle >{{ item.url_hash }}</v-list-item-subtitle> -->
<!-- </v-list-item-content> -->

<!-- <v-list-item-action /> -->
<!--       <v-list-item-avatar
tile
size="80"
color="grey"
></v-list-item-avatar> -->

<!--           </v-list-item-content>
</v-list-item> -->
          <!-- <v-list-item-title class="text mb-2">{{ cardio.note }}</v-list-item-title> -->
<!--           <v-list-item-subtitle
            @click="showPreview()"
            class="caption ma-2"
          > -->

<!--       <v-img
        height="120"
        @click="showPreview()"
        src="https://via.placeholder.com/320x240.jpg?text=Click+for+Preview"
      />
 -->
<!--       <v-list-item three-line>
        <v-list-item-content>
 -->

<!--
<v-btn icon>
<v-icon>edit</v-icon>
</v-btn>
-->


